/** @format */

import {
	BranchIoResponse,
	Chain,
	DeepLinkOptions,
	Environment
} from '@shared/data-access/interfaces';

import { HttpService } from './http.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { MediaType } from '@shared/data-access/enums';

@Injectable({
	providedIn: 'root'
})
export class BranchIoDao {
	constructor(
		private http: HttpService,
		private environment: Environment,
		private chain: Chain
	) {}

	// Default HTTP Header properties
	private DEFAULT_HTTP_HEADER_PROPERTIES = {
		Accept: MediaType.APPLICATION_JSON,
		// eslint-disable-next-line @typescript-eslint/naming-convention
		'Content-Type': MediaType.APPLICATION_JSON
	};

	/**
	 * @description
	 * Creates a deep link using the Branch.io API
	 */
	public createDeepLink(options: DeepLinkOptions): Observable<BranchIoResponse> {
		const httpOptions = {
			headers: this.DEFAULT_HTTP_HEADER_PROPERTIES
		};

		/* eslint-disable @typescript-eslint/naming-convention */
		const parameters = {
			branch_key:
				this.environment.apiTokens.branchIo[this.chain.chainIdentifierAbbr].branchKey,
			channel: 'web',
			feature: options.feature,
			data: {
				$android_url: options.url,
				$canonical_url: options.canonicalUrl,
				$desktop_url: options.url,
				$ios_url: options.url,
				camp: options.camp
			}
		};
		/* eslint-enable @typescript-eslint/naming-convention */

		return this.http.post<BranchIoResponse>(
			`${this.environment.baseUrls.branchIoApi}/v1/url`,
			parameters,
			httpOptions
		);
	}
}
